<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/TBOX2/TBOX2.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">2<span>nd</span>&nbsp; Gen TBOX</div>
                <div class="detail-banner-desc">
                    It integrates Vehicle-to-Everything (V2X) capabilities to enable vehicle-road-cloud collaboration, supports Multi-Mode Multi-Fre(L1,L5/L2) GNSS, can reach Centi-meter level accuracy position;<br />
                    Configure the inner core Q’ty(2/3/4), the calculation power up to 21.6 K DMIPS, High-Speed Data Transmission: Supports peak downlink speeds of 2.5 Gbps and uplink speeds of 625 Mbps, support C-V2X 16 scenes(up to 34);<br />
                    Convenient service provided: 30 remote control and 30+ data upload, offering user convenience while improving the operational efficiency of Original Equipment Manufacturers (OEMs);<br />
                    Safety Assurance: Equipped with emergency call (eCall) response and IBCall, providing comprehensive protection and information for occupants;<br />
                    Commitment to Innovation: The T-Box series reflects our unwavering pursuit of advanced connectivity, safety guarantees, and user-centric solutions, helping to realize smarter and safer mobility.
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>
                    <div class="detail-desc">
                        <div>
                            Supports 2/3/4/5G(NR) and C-V2X, Data Rate up to 2.5 G (DL)/ 625M(UL) bps.
                        </div>
                        <div>
                            Supports 3GPP Rel-16 Sub-6SA/NSA100MHz.
                        </div>
                        <div>
                            Platform Design, design compatible 5G/5G+DSDS/5G+V2X/5G+DSDS+V2X.
                        </div>
                        <div>
                            Integrated Multi-mode Multi-Frequency GNSS, Reserve alone GNSS module。
                        </div>
                        <div>
                            Ethernet communication, 1000 Base-T1.
                        </div>
                        <div>
                            FOTA, DSDS
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/TBOX2/TBOX2-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Quad core ARM Cortex-A55</div>
                                    <div class="k">CPU core</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">up to 2.0 GHz</div>
                                    <div class="k">CPU frequency</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">21.6K DMIPS</div>
                                    <div class="k">Computing Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1000 Base-T1</div>
                                    <div class="k">Ethernet</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Sub-dm</div>
                                    <div class="k">Position Accuracy</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">4nm</div>
                                    <div class="k">Process</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Up to 2.5 G / 625M bps</div>
                                    <div class="k">DL/UL Data rate</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">8Gb LPDDR4X+8Gb Nand Flash</div>
                                    <div class="k">Memory</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/TBOX2/TBOX2-1.jpg" alt="200-1-02">
                    </div>
                </div> -->

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: '2ⁿᵈ Gen TBOX - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/electronics/TBOX2.html'
};

import { createApp } from 'vue';
import App from './TBOX2.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./TBOX2.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
